import DataFilter from "./datafilter"
import TemperatureFilter from "./temperaturefilter"
import PressureFilter from "./pressurefilter"
import EngineHourFilter from "./enginehourfilter"
import EventFilter from "./eventfilter"
import LocaleDateFilter from "./localedatefilter"
import OptionalTextFilter from "./optionaltextfilter"
import TimeFilter from "./timefilter"
import TruncateTextFilter from "./truncatetextfilter"

export default {
  localeDateFilter: LocaleDateFilter,
  optionalTextFilter: OptionalTextFilter,
  eventFilter: EventFilter,
  timeFilter: TimeFilter,
  dataFilter: DataFilter,
  engineHourFilter: EngineHourFilter,
  truncateTextFilter: TruncateTextFilter,
  temperatureFilter: TemperatureFilter,
  pressureFilter: PressureFilter
}
